import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { ImmigrationProfessional } from '../models';

export function get(
    serviceProviderId?: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ImmigrationProfessional[]>> {
    const url = '/immigration_professionals' + (serviceProviderId ? `/${serviceProviderId}` : '');
    return client.get<ImmigrationProfessional[]>(url, customConfig);
}
